import { getDefaultFeatures } from '@/App/Service/Feature';

/**
 * @type interface
 */
export interface IStoreState {
	apiVersion: string | null;
	appSettings: Record<string, any>;
	deviceId: string | null;
	features: IFeatures;
	feedStructure: IFeedStructure[];
	locationDenied: boolean;
	onboardingComplete: boolean;
	pushToken: string | null;
	pwaInstallStatus?: 'accepted' | 'dismissed' | null;
	useLocation: boolean;
	useRemoteFeed: boolean;
}

/**
 * @class State
 * @package Store/Module/Settings
 * @project ChalkySticks App
 */
const state: IStoreState = {
	apiVersion: null,
	appSettings: {},
	deviceId: null,
	features: getDefaultFeatures() as IFeatures,
	feedStructure: [],
	locationDenied: false,
	onboardingComplete: false,
	pushToken: null,
	pwaInstallStatus: null,
	useLocation: false,
	useRemoteFeed: true,
};

export default state;
